var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "top" } }, [
      _c(
        "div",
        { staticClass: "btnback", on: { click: _vm.handleClickBack } },
        [_c("p", [_vm._v("BACK")])]
      ),
    ]),
    _vm._v(" "),
    _c("iframe", {
      style: _vm.iframe.style,
      attrs: {
        "v-if": _vm.loaded,
        src: _vm.iframe.src,
        height: _vm.iframe.style != null ? _vm.iframe.style.height : 0,
        width: _vm.iframe.style != null ? _vm.iframe.style.width : 0,
        frameborder: "0",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }